module.exports = __webpack_public_path__ + "static/media/colla360.6f649970.jpg";